
const LineshapeSchemaReducer = (state = { schemas: null }, action) => {
    if (action.type === 'SET_LINESHAPE_SCHEMAS') {
        return { schemas: action.payload };
    }
    return state;
}
export default LineshapeSchemaReducer;

